module.exports = __webpack_public_path__ + "img/sub_manual.7d00a80f.png";